/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Ketemu Orang Baru, Ngobrol, Bergaul",
      "Nomor telepon salah",
      "Get the app",
      "Lanjut dengan Apple",
      "Lanjut dengan Facebook",
      "Lanjut dengan Google",
      "Masuk",
      "Daftar",
      "Untuk lanjut, masukkan karakter yang kamu lihat.",
      "Lanjut",
      "Masukkan karakter",
      "Pemeriksaan keamanan",
      "Muat ulang",
      "Buat kata sandi baru yang mudah diingat:",
      "Perbarui",
      "Konfirmasi kata sandi",
      "Kata sandi harus setidaknya {{num}} [[characters:num]]",
      "Kata sandi",
      "Buat kata sandi baru",
      "Badoo - The Blog",
      "Karir",
      "Ngobrol",
      "Kota",
      "Atur cookies",
      "Hak Cipta © 2006 – sekarang. Bumble. Semua hak dilindungi undang-undang.",
      "Apple dan logo Apple adalah merek dagang dari Apple Inc.{{__EOL__}}Google Play adalah merek dagang dari Google LLC.",
      "Download",
      "Facebook",
      "Ikuti kami",
      "Pusat Bantuan",
      "Instagram",
      "Bahasa",
      "LinkedIn",
      "Ringkasan",
      "Badoo adalah bagian dari Bumble Inc.",
      "Kebijakan privasi",
      "Pusat Keamanan",
      "Peta situs",
      "Pernyataan Akta Perbudakan Moderen",
      "Syarat dan ketentuan",
      "Twitter",
      "Masukkan email atau nomor ponsel dan kami akan mengirimkan instruksi untuk membuat kata sandi baru.",
      "Dapatkan kata sandi baru",
      "Masukkan email atau nomor ponsel",
      "Lupa kata sandi",
      "Model yang digunakan hanya untuk tujuan ilustrasi",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Tidak perlu menunggu dijodohkan.{{__EOL__}}{{__EOL__}}Mengobrol lebih dalam dan langsung ke intinya. Benar-benar saling mengenal satu sama lain.",
      "Siap ngobrol sekarang?",
      "Dengan mendaftar, kamu menyetujui <a class=\"link\" href=\"{{terms_url}}\">Syarat dan Ketentuan</a> kami. Pelajari bagaimana kami menggunakan datamu di <a class=\"link\" href=\"{{privacy_url}}\">Kebijakan Privasi</a> kami.",
      "Membantu menampilkan dirimu yang sesungguhnya, <br />untuk koneksi yang bermakna.",
      "Ayo berkencan dengan percaya diri.",
      "Atau",
      "Sudah punya akun?",
      "Daftar dengan email atau ponsel",
      "Dapatkan yang kamu mau dari dating.{{__EOL__}}Tidak perlu minta maaf.",
      "Cuma mau ngobrol? Tidak apa.{{__EOL__}}Mau serius? Tentu boleh.{{__EOL__}}{{__EOL__}}Dan kalau kamu berubah pikiran, bisa kapan saja.",
      "Mau berkencan",
      "Siap untuk sebuah hubungan",
      "Mau mengobrol",
      "Temui orang yang mau hal yang sama.",
      "{{name}}, {{age}}",
      "Keamananmu adalah prioritas no.1 kami.",
      "Pusat Keamanan kami adalah pusat pengetahuan, berisi semua dukungan yang kamu perlukan untuk kencan dengan yakin.",
      "Kunjungi Pusat Keamanan kami",
      "Keamanan pertama,<br/>kedua, dan seterusnya.",
      "Dari momen pertama, aku sudah merasa ada yang berbeda...",
      "Awalnya, aku tidak mencari yang serius...",
      "Satu saran untuk semua orang di Badoo, jadilah dirimu sendiri...",
      "Cerita Sukses Badoo",
      "Lihat lebih banyak cerita sukses",
      "{{num}}__CUT__Nilai",
      "Apple App Store",
      "Percaya kami. Kami sudah menjodohkan berjuta-juta (dan berjuta, dan berjuta) orang sejak 2006.",
      "{{num}}M+__CUT__Downloads",
      "{{num}}JT+",
      "Google Play Store",
      "Kami adalah ahlinya.",
      "Masuk dengan email atau nomor ponsel kamu",
      "Masukkan kata sandi",
      "Lupa kata sandi?",
      "Daftar",
      "Tidak punya akun?",
      "Masuk",
      "Daftar"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "huruf"
            ],
            "singular": [
                  "huruf"
            ]
      },
      "day": {
            "plural": [
                  "hari"
            ],
            "singular": [
                  "hari"
            ]
      },
      "hour": {
            "plural": [
                  "jam"
            ],
            "singular": [
                  "jam"
            ]
      },
      "minute": {
            "plural": [
                  "menit"
            ],
            "singular": [
                  "menit"
            ]
      },
      "month": {
            "plural": [
                  "bulan"
            ],
            "singular": [
                  "bulan"
            ]
      },
      "second": {
            "plural": [
                  "detik"
            ],
            "singular": [
                  "detik"
            ]
      },
      "year": {
            "plural": [
                  "tahun"
            ],
            "singular": [
                  "tahun"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
